import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from '../pages/login/index';
import Registration from '../pages/Registration/index'
import Supplier from "../pages/suppliers";
import Profile from '../pages/profile/Index'
import Dashboard from '../pages/admin/dashboard/index'
import AdminRFQ from '../pages/rfq/manage/index'
import UserVerification from '../pages/userVerfication.js'
import ViewRFQ from '../pages/rfq/view/index'
import NotFound from "../pages/notFound";
import { utilities } from "../utilities/utlities";
import Profiles from "../pages/admin/profiles";
import CustomHeader from '../components/Header/index'
import ForgetPassword from '../pages/forgetPassword/index'
import CustomFooter from '../components/Footer/index'
import ViewProfile from "../pages/viewProfile";
import Invite from "../pages/invite";
import CompanyUsers from "../pages/companyUsers";
import { useQuery } from 'react-query'
import { useState } from "react";
import { Menus } from "./api";
import { useEffect } from "react";
import ManageRFI from "../pages/rfi/manage";
import ViewRFI from "../pages/rfi/view";
import AddToProduct from '../pages/addToProduct/index'
import ManageContact from "../pages/manageContact";
import Marketplace from '../pages/marketplace/Index';
import Products from "../pages/marketplace/listingProducts/Products";
import ProductList from '../pages/admin/products/index'
export default function Routing() {
  const [headerMenu, setMenuHeader] = useState([])
  const [footer, setFooterMenu] = useState([])
  const ongetSuccess = (data) => {
    console.log("menus found successfully")
    console.log(data)
    setMenuHeader(data?.data?.heaeder)
    setFooterMenu(data?.data?.footer)
  }
  const ongetError = (err) => {
    console.log("get menus error")
    console.log(err)

  }
  const { isLoading, refetch } = useQuery(['UserMenu'], async () => {
    // console.log("refetch is called")
    const loginUser = utilities.loggedUser()
    // console.log(loginUser)
    return await Menus.getUserMenus(loginUser?.jwtToken)
  }, {
    enabled: false,
    onSuccess: ongetSuccess,
    onError: ongetError,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60

  })
  useEffect(() => {
    getMenu()
  }, [])
  const getMenu = ()=>{
    const user = JSON.parse(localStorage.getItem("loggedUser"))
    if(user != null){
    refetch()
    }
  }
  return (
    <BrowserRouter>
      <CustomHeader menu={headerMenu} />
      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route path="/login" element={<Login getMenu={getMenu} />}></Route>
        <Route path="/reset_password" element={<ForgetPassword/>}>
        </Route>
        <Route path="/registration" element={<Registration />}>
        </Route>
        <Route path="/profile/edit" element={<Profile />}>
        </Route>
        <Route path="/admin/dashboard" element={<Dashboard />}>
        </Route>
        <Route path="/marketplace" element={<Marketplace />}>
        </Route>

        <Route path="/marketplace/products" element={<Products />}>
        </Route>
        <Route path="/rfq" element={
          <RequireAuth roles={['admin','distributor']} component={<AdminRFQ />} />
        }>
        </Route>
        <Route path="/userVerification" element={<UserVerification />}>
        </Route>
        <Route path="/productList" element={<ProductList />}>
        </Route>
        <Route path="/profile" element={<ViewProfile />}></Route>
        <Route path="/profile/edit/:id" element={<ViewProfile />}></Route>
        <Route path="/rfq/:id" element={
          <RequireAuth component={<ViewRFQ />} />
        }>
        </Route>
        <Route path="/profiles/:type" element={
          <RequireAuth roles={['admin']} component={<Profiles />} />
        }>
        </Route>
        <Route path="/supplier/:id" element={
          <RequireAuth roles={['supplier']} component={<ViewRFI />} />
        }>
          
        </Route>
        <Route path="/supplier" element={
          <RequireAuth roles={['supplier']} component={<ManageRFI />} />
        }>
          
        </Route>
        <Route path="/invite" element={
          <RequireAuth component={<Invite />} />
        }>
        </Route>
        {/* <Route path="/manage-users" element={ */}
        <Route path="/manage-contact" element={
          <RequireAuth component={<ManageContact />} />
        }>
        </Route>
        <Route path="/manage-users" element={
          <RequireAuth component={<CompanyUsers />} />
        }>
        </Route>
        <Route path="/manage-rfi/:id" element={
          <RequireAuth component={<ManageRFI />} />
        }>
        </Route>
        <Route path="/rfi/:rfqId/:id" element={
          <RequireAuth component={<ViewRFI />} />
        }>
        </Route>
        <Route path="/add-to-product" element={
          <RequireAuth component={<AddToProduct />} />
        }>
        </Route>
        <Route path="/not-found" element={<NotFound accessDenied />}>
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      <CustomFooter footer={footer} />
    </BrowserRouter>
  )
}
const RequireAuth = ({ roles, component }) => {
  let user = utilities.loggedUser()
  let authorized = true
  if (!user) {
    authorized = false
  } else {
    if (roles) {
      if (roles.indexOf(user.type) < 0) {
        authorized = false
      }
    }
  }
  if (authorized) {
    return component
  }
  return <Navigate to="/not-found" replace />
}

